import { Button, Group, Modal } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import BackButton from "./BackButton";
import { Link } from "react-router-dom";
import { IconEdit } from "@tabler/icons-react";
import MessageVocalPreviewer from "./MessageVocalPreviewer";

const VocalMessagePreview = ({ opener, model, disableEdit }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      {opener ? (
        opener(open)
      ) : (
        <Button variant="light" onClick={open} size="md">
          {lang.components.email_preview.button_label}
        </Button>
      )}
      <Modal
        opened={opened}
        onClose={close}
        title={"Prévisuel"}
        size={"40%"}
        centered
      >
        <MessageVocalPreviewer model_id={model?.id} />

        <Group justify="end" mt={16}>
          <BackButton onClick={close} size="md" />
          {!disableEdit && (
            <Button
              component={Link}
              leftSection={<IconEdit size={18} />}
              size="md"
              to={`/models/linkedin-voice-message/${model?.id}`}
            >
              {lang.api_keys.edit.button_label}
            </Button>
          )}
        </Group>
      </Modal>
    </>
  );
};

export default VocalMessagePreview;
